import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
// import app from './modules/app'
import user from './modules/user'
import column from './modules/column'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: getters,
  modules: {
    // app,
    user,
    column
  }
})
